import { Component, OnInit, inject } from '@angular/core';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';

@Component({
    selector: 'app-contact-verification-success',
    templateUrl: './contact-verification-success.component.html',
    styleUrls: ['./contact-verification-success.component.css'],
    standalone: true
})
export class ContactVerificationSuccessComponent implements OnInit {
  cservice = inject(ContactVerificationService);


  ngOnInit(): void {
  }

}
